import React from 'react';
import { useTranslation } from 'react-i18next';

const CalendarLegend = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex gap-[4px] items-center">
        <div className="w-[20px] h-[4px] bg-green-1000" />
        <p className="p3-regular">
          {t('ticketSale.calendarDayStatuses.available')}
        </p>
      </div>
      <div className="flex gap-[4px] items-center">
        <div className="w-[20px] h-[4px] bg-orange-1000" />
        <p className="p3-regular">
          {t('ticketSale.calendarDayStatuses.filling-up-fast')}
        </p>
      </div>
      <div className="flex gap-[4px] items-center">
        <div className="w-[20px] h-[4px] bg-red-1000" />
        <p className="p3-regular">
          {t('ticketSale.calendarDayStatuses.sold-out')}
        </p>
      </div>
      <div className="flex gap-[4px] items-center">
        <div className="w-[20px] h-[20px] bg-neutral-40" />
        <p className="p3-regular">
          {t('ticketSale.calendarDayStatuses.unavailable')}
        </p>
      </div>
    </>
  );
};

export default CalendarLegend;
